<template>
  <span class="message-status">
    <b-spinner v-if="isSending" small></b-spinner>
    <span :class="{ 'sending-text': isSending }">{{ text }}</span>
  </span>
</template>

<script>
export default {
  name: 'MessageSendStatus',

  props: {
    isSending: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.message-status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.sending-text {
  opacity: 0.7;
}

.b-spinner {
  margin-right: 5px;
}
</style>
